
import { ModalBox, StyledButton } from './styles.js';

import Icon from '@icons';
import Modal from '@material-ui/core/Modal';
/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';
/**
 * ReactDOM é um pacote que fornece métodos específicos do DOM que podem
 * ser usados no nível superior do seu aplicativo e como uma saída de 
 * emergencia para sair do modelo React.
 */
import ReactDOM from 'react-dom';

/**
 * ReactDOM.render() função recebe dois argumentos, codigo HTML e um 
 * elemento html, a função tem como objetivo exibir o codigo HTML espe-
 * cificado dentro do elemento HTML especificado.
 */
const onClose = () => {
  ReactDOM.render(null, document.getElementById('alert'));
};

/**
 * Alert é um substituto do window.alert() nativo do javascript com
 * a diferença de que esse está estilizado em um modal com a identidade
 * visual do projeto. Apenas um alert por vez pode ser disparado.
 * Também é possível disponibilizar a opção 'Não mostre novamente' para o 
 * usuário com um timer de reexibição predefinido.
 */
export const NoticeNotRun = ({ title, message, buttonText }) => {  
  return (
    <div className="modalConfirm" style={{ zIndex: 2000 }}>
      <Modal style={{ zIndex: 2000 }} open={true} onClose={onClose}>
        <ModalBox>
          <button onClick={onClose} className="close">
            <Icon i="all-close" />
          </button>
          <header>
            <h2>{title}</h2>
          </header>
          <div className="content"><p>{message}</p></div>
          <footer>
            <div className='button'>
              <StyledButton
                variant="contained"
                color="primary"
                onClick={onClose}
              >
                {buttonText}
              </StyledButton>
            </div>
          </footer>
        </ModalBox>
      </Modal>
    </div>
  );
};

NoticeNotRun.propTypes = {
  /** Titulo do Alerta */
  title: PropTypes.string,
  /** Mensagem do Alerta */
  message: PropTypes.string.isRequired,  
  /** Texto do botão do Alerta */
  buttonText: PropTypes.string,
};

export default NoticeNotRun;
